module.exports = __webpack_public_path__ + "94c38f138c67c8389b8c0630b3248b78.pdf";